import styled from "styled-components";

export const LiveCasinoGridItemSkeletonWrapperBox = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${props => props.theme.components.newLiveCasino.colors.gridItem.wrapperBorder};
    border-radius: 3px;
    overflow: hidden;
`;